import notify from './notify'

export const GRAPHQL_INPUT_ERROR_CODE = 'INPUT_ERROR'

export function getGraphQLInputError (error) {
  if (!Array.isArray(error?.response?.errors)) return null

  return error.response.errors.find(err => err?.extensions?.code === GRAPHQL_INPUT_ERROR_CODE) || null
}

export function captureError (error) {
  console.error(error)
  // TODO send the error to rollbar or sentry or whatever tool we choose
}

export function captureErrorAndNotify (error, message, time = 2) {
  captureError(error)
  notify('error', message, time)
}

export function handleQBOInvoiceExportError (error) {
  if (error.message.search('Hauler is not connected to QuickBooks') !== -1) {
    return captureErrorAndNotify(error, 'Error exporting invoice: Hauler not connected. Please connect hauler to QuickBooks.', 6)
  } else if (error.message.search('not exported to QuickBooks') !== -1) {
    return captureErrorAndNotify(error, 'Error exporting invoice: Account export issue. Please export account to QuickBooks.', 6)
  }
  return captureErrorAndNotify(error, 'Error exporting invoice to Quickbooks.', 6)
}

export function handleValidateAndNotify (error, fallbackMessage) {
  const inputError = getGraphQLInputError(error)
  if (inputError) {
    notify('error', inputError.message, 4)
    return
  }
  captureError(error)
  notify('error', fallbackMessage, 4)
}
